import { Flex } from '@fastnorth/kraken/components/layout';
import { type ReactElement, type ReactNode, useLayoutEffect, useRef, useState } from 'react';

export type CertificateScalingWrapperProps = {
  children: ReactNode;
  height: number;
  width: number;
};

const CertificateScalingWrapper = ({
  children,
  height,
  width,
}: CertificateScalingWrapperProps): ReactElement => {
  const viewportRef = useRef<HTMLDivElement | null>(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const viewport = viewportRef.current;
    if (!viewport) return;

    const updateScale = (): void => {
      const viewportWidth = viewport.getBoundingClientRect().width;
      if (viewportWidth > 0) {
        setScale(viewportWidth / width);
      }
    };

    updateScale();
    const resizeObserver = new ResizeObserver(updateScale);
    resizeObserver.observe(viewport);

    return () => resizeObserver.disconnect();
  }, [width]);

  return (
    <Flex
      ref={viewportRef}
      className={'relative w-full overflow-hidden pointer-events-none select-none'}
      data-testid={'visible-certificate-viewport'}
      inert
      style={{ height: `${height * scale}px` }}>
      <Flex
        className={'absolute left-0 top-0 flex-col overflow-hidden'}
        data-testid={'visible-certificate'}
        style={{
          height: `${height}px`,
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          width: `${width}px`,
        }}>
        {children}
      </Flex>
    </Flex>
  );
};

export default CertificateScalingWrapper;
